/* global Flickity */

// Add and remove a resizing class to get equal height cells
const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

// Initialize Flickity on media sliders
const initFlickity = (mediaSliders) => {
  mediaSliders.forEach((mediaSlider) => {
    const flkty = new Flickity(mediaSlider, {
      pageDots: false,
      freeScroll: true,
      freeScrollFriction: 0.1,
      imagesLoaded: true,
      cellAlign: 'center',
      contain: true,
    });

    // Recalc position from unhide/lazy load
    window.addEventListener('load', () => {
      flkty.reloadCells();
      flkty.resize();
    });
  });
};

const init = () => {
  const mediaSliders = document.querySelectorAll('[data-ref="media-slider"]');

  if (mediaSliders && mediaSliders.length) {
    initFlickity(mediaSliders);
  }
};

init();
